export default "__VITE_ASSET__d4b2c47a__"